class KeetsaTabs extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.tablist = this.querySelector('[role="tablist"]');
    if (!this.tablist) return;

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length === 0) return;

    this._abortController = new AbortController();
    const { signal } = this._abortController;
    this.tablist.addEventListener('click', this.onClick.bind(this), { signal });
    this.tablist.addEventListener('keydown', this.onKeydown.bind(this), { signal });
  }

  disconnectedCallback() {
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
    this._initialized = false;
  }

  onClick(event) {
    if (!(event.target instanceof Element)) return;
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const index = this.tabs.indexOf(tab);
    if (index === -1) return;
    this.activate(index, false);
  }

  onKeydown(event) {
    const current = this.tabs.indexOf(document.activeElement);
    if (current === -1) return;
    let next = -1;
    if (event.key === 'ArrowRight') {
      next = (current + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft') {
      next = (current - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = this.tabs.length - 1;
    }
    if (next === -1) return;
    event.preventDefault();
    this.activate(next, true);
  }

  activate(index, focus) {
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      tab.classList.toggle('keetsa-tabs__tab--active', isActive);
    });
    this.panels.forEach((panel, i) => {
      if (i === index) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    if (focus && this.tabs[index] instanceof HTMLElement) {
      this.tabs[index].focus();
    }
  }
}

if (!customElements.get('keetsa-tabs')) {
  customElements.define('keetsa-tabs', KeetsaTabs);
}
